import { motion, AnimatePresence } from "framer-motion";

const Lightbox = ({ img, onClose }: { img: string | null; onClose: () => void }) => (
  <AnimatePresence>
    {img && (
      <motion.div
        className="fixed inset-0 bg-deepSlate/80 z-50 flex items-center justify-center"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        onClick={onClose}
      >
        <motion.img
          src={img}
          className="max-w-[90vw] max-h-[90vh] rounded-lg"
          initial={{ scale: 0.8 }}
          animate={{ scale: 1 }}
        />
      </motion.div>
    )}
  </AnimatePresence>
);

export default Lightbox;
